module.exports = {
    DEBUG_STRINGS: 'debugStrings',
    DEBUG_FLAG_ON: 'ON',
    DEBUG_FLAG_OFF:'OFF',
};
